<dk-password-popup
  titleText="Şifre Değiştir"
  [visible]="visible"
  [width]="300"
  [height]="200"
  [wrapperAttr]="{ class: 'change-profile-password-popup' }"
  (save)="saveNewPassword($event)"
  (visibleChange)="changeVisible($event)"
>
<ng-container *ngIf="visible">
<dx-form
    #form
    class="form"
    labelMode="outside"
    labelLocation="left"
    [showColonAfterLabel]="true"

  >
    <dxi-item>
      <dxo-label text="Güncel Şifreniz"></dxo-label>
      <dk-password-textbox
        stylingMode="filled"
        [(value)]="formData['currentPassword']"
        (valueChanged)="onFieldChanged()"
      ></dk-password-textbox>
    </dxi-item>

    <dxi-item>
      <div class="h-separator"></div>
    </dxi-item>

    <dxi-item>
      <dxo-label text="Şifre"></dxo-label>
      <dk-password-textbox
        stylingMode="filled"
        [(value)]="formData['password']"
        (valueChanged)="onNewPasswordChanged()"
      ></dk-password-textbox>
    </dxi-item>

    <dxi-item>
      <dxo-label text="Şifreyi Doğrula"></dxo-label>
      <dk-password-textbox
        #confirmField
        stylingMode="filled"
        [(value)]="formData['confirmedPassword']"
        [validators]="confirmedPasswordValidators"
        (valueChanged)="onFieldChanged()"
      >
      </dk-password-textbox>
    </dxi-item>
  </dx-form>
</ng-container>
  
</dk-password-popup>
